import { render, staticRenderFns } from "./ConsumptionReportKPI.vue?vue&type=template&id=d30b6da2&lang=pug"
import script from "./ConsumptionReportKPI.vue?vue&type=script&lang=js"
export * from "./ConsumptionReportKPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d30b6da2')) {
      api.createRecord('d30b6da2', component.options)
    } else {
      api.reload('d30b6da2', component.options)
    }
    module.hot.accept("./ConsumptionReportKPI.vue?vue&type=template&id=d30b6da2&lang=pug", function () {
      api.rerender('d30b6da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConsumptionReportKPI.vue"
export default component.exports